export default __webpack_public_path__ + "72b20cee8343108274cba35b2e17b800.png";